import { useMutation, useQueryClient } from '@tanstack/react-query';
import toursOptionApi from '@/features/dashboard/tourOptions/api/tourOptionsApi.ts';
import { toast } from 'sonner';
import { tourOptionsApiQueryKeys } from '@/features/dashboard/tourOptions/api/tourOptionsApi.queryKeys.ts';
import { TourOptionErrorKeys } from '@/features/dashboard/tourOptions/api/tourOptionErrors.ts';
import { isKnownBackendErrorKey } from '@/lib/api/exception.ts';
import { invalidateTourStatsQueries } from '@/utils/invalidateTourStatsQueries.ts';

export default function useRemoveTourOption(tourId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: toursOptionApi.remove,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: tourOptionsApiQueryKeys.byTourId(tourId),
      });
      invalidateTourStatsQueries(queryClient, tourId);
      toast.success('Opcja wyjazdu została usunięta');
    },
    onError: (error: Error) => {
      if (isKnownBackendErrorKey(error, TourOptionErrorKeys.OPTION_IN_USE)) {
        toast.error('Nie można usunąć opcji', {
          description:
            'Opcja jest używana w istniejących rezerwacjach. Zamiast usuwać, zarchiwizuj ją — zniknie z oferty, ale pozostanie widoczna w rezerwacjach.',
        });
        return;
      }
      toast.error('Wystąpił błąd', {
        description:
          error.message || 'Wystąpił błąd podczas usuwania opcji wyjazdu.',
      });
    },
  });
}
